import React, { useRef, useEffect } from 'react';
import ImageLayer from './ImageLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';
import {cloneDeep} from "lodash";

export default function(props) {
    const {
        url,
        params,
        id: key,
        _key,
        group,
        show,
        zIndex,
        ...otherProps
    } = props;

    const layerRef = useRef();
    const { map, groupLayer } = useProps();

    useEffect(() => {
        let layer = new ImageLayer({
            url,
            params,
            key: key || _key,
            show,
            map,
            groupLayer,
            zIndex,
            group: group && cloneDeep(group),
            ...otherProps,
        });
        // 注册事件
        registerEventLayer(layer, props);

        if (groupLayer) {
            let groupIndex, mapIndex;
            if (layerRef.current) {
                groupIndex = layerRef.current.getGroupIndex();
                mapIndex = layerRef.current.getMapIndex(groupLayer.key);
            } else {
                mapIndex = map.getImageryLastIndex(zIndex);
            }

            groupLayer.addLayer(layer, groupIndex, mapIndex);
        } else {
            let mapIndex;
            if (layerRef.current) {
                mapIndex = layerRef.current.getMapIndex();
            } else {
                mapIndex = map.getImageryLastIndex(zIndex);
            }

            map.addLayer(layer, mapIndex);
        }


        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                layerRef.current && groupLayer.removeLayer(layerRef.current);
            } else {
                layerRef.current && map.removeLayer(layerRef.current);
            }
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    useUpdateEffect(() => {
        layerRef.current.setGroup(group, params);
    }, [JSON.stringify(group)]);

    useUpdateEffect(() => {
        layerRef.current.updateParams(params, group);
    }, [JSON.stringify(params)]);

    return <></>;
}
